import { render, staticRenderFns } from "./addCheckCidDialog.vue?vue&type=template&id=67e4e28d&"
import script from "./addCheckCidDialog.vue?vue&type=script&lang=js&"
export * from "./addCheckCidDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports